module.exports = __webpack_public_path__ + "static/media/coupa_logo2013_RGB_rev_LowRes_icon.489f3cf8.png";